import { useTranslation } from 'react-i18next';
import { withForm } from '@/shared/components/form/form';
import { defaultValues } from '../types/goals.types';
import { Label } from '@radix-ui/react-label';
import { Plus, Target } from 'lucide-react';
import { defaultKeyResult, KeyResultField } from './KeyResultField';
import { Button } from '@/shared/components/ui/Button';
import { EmptyKeyResults } from './EmptyKeyResults';

export const KeyResultsField = withForm({
  defaultValues,
  render: function KeyResultsField({ form }) {
    const { t } = useTranslation('goals');

    return (
      <form.AppField name="keyResults" mode="array">
        {(field) => {
          const keyResults = field.state.value ?? [];
          const hasKeyResults = keyResults.length > 0;

          return (
            <div className="space-y-4">
              {/* Header Section */}
              <div className="space-y-1.5">
                <div className="flex items-center gap-2">
                  <Target className="h-5 w-5 text-primary" />
                  <Label className="text-base font-semibold">
                    {t('keyResultsLabel')}
                  </Label>
                </div>
                <p className="text-sm text-muted-foreground">
                  {t('keyResultsDescription')}
                </p>
              </div>

              {/* Key Results List */}
              {hasKeyResults ? (
                <div className="space-y-3">
                  {keyResults.map((_, index) => (
                    <KeyResultField
                      key={index}
                      index={index}
                      fields={`keyResults[${index}]`}
                      form={form}
                      onRemove={() => field.removeValue(index)}
                    />
                  ))}
                  {/* Add More Button */}
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => field.pushValue({ ...defaultKeyResult })}
                    className="border"
                  >
                    <Plus className="h-4 w-4 mr-2" />
                    {t('addKeyResult')}
                  </Button>
                </div>
              ) : (
                /* Empty State */
                <EmptyKeyResults
                  onAddClick={() => field.pushValue({ ...defaultKeyResult })}
                />
              )}
            </div>
          );
        }}
      </form.AppField>
    );
  },
});
